/** The applicable set size — the "Browse all N brands" denominator (#24). */
export function applicableCount(state) {
  return state.options.length;
}

/**
 * Whether the client is refusing to show count digits — the degraded refetch
 * state (#30).
 *
 * Derived rather than stored, because it is exactly "a fetch failed after one
 * had already succeeded". A refetch failure leaves `options` and `selected`
 * in place, so the previous list stays usable for selection; but those counts
 * described a filter context the buyer has since left, so their digits are no
 * longer true and are withheld. An initial-load failure has no previous list to
 * degrade and is the error state with a retry instead.
 *
 * Kept derived deliberately: a stored flag would be a third thing every
 * mutation had to remember, and the one way it could drift — digits shown for a
 * failed context, or ranking by numbers the client refuses to show — is exactly
 * what this facet must never do.
 *
 * It stays true across the in-flight retry: `startRequest` does not clear
 * `error`, so the stale digits cannot flash back before the new payload lands.
 */
export function countsWithheld(state) {
  return state.error && state.loadedOnce;
}
